// extracted by mini-css-extract-plugin
module.exports = {"council":"council_council__1qyJ7","members":"council_members__2jrq5","member_container":"council_member_container__FGYO7","member_card":"council_member_card__3tyeC"};